import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

interface UseTmaisFaqsProps<T> {
  filters?: {
    page?: number
  }
  mapper?: (data: any) => T
}

export const useTmaisFaqs = <T,>({ filters: { page } = {}, mapper = Mapper.default<T>() }: UseTmaisFaqsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['tmaisFaqs', page],
    queryFn: () => {
      return privateAxios.get('/tmais/faqs', {
        params: { page },
      })
    },
    select: (response: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(response?.data?.data),
        meta: response?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
